import * as React from 'react';
import { Button, ButtonGroup } from 'react-bootstrap';

import { humanize } from '../gs-core/common';

import { Subject } from '../common/models';
import { SubjectSelection } from '../services';

interface SubjectTypeSelectorProps {
  subjectSelection: SubjectSelection;
  onChange: (subject: Subject) => void;
  className?: string;
}

export const SubjectTypeSelector = ({ subjectSelection, onChange, className }: SubjectTypeSelectorProps) => {
  const selectedType = subjectSelection.selectedSubject.type;

  return (
    <ButtonGroup className={className}>
      {subjectSelection.allSubjects.map(subject =>
        (
          <Button
            key={subject.type}
            onClick={() => onChange(subject)}
            className={selectedType === subject.type ? 'active' : ''}
          >
            {humanize(subject.type)}
          </Button>
        )
      )}
    </ButtonGroup>
  );
};



// WEBPACK FOOTER //
// ./src/Subject/SubjectTypeSelector.tsx